import React from 'react';
import './Loader.css';

const Loader = ({ show = false, message = '' }) =>
  show ? (
    <>
      <div className="loader-wrapper">
        <span className="message">{message}</span>
        {/* <i className="loading-icon" /> */}
        <i className="fa fa-spinner fa-spin" />
      </div>
      <div className="loader-modal-container" />
    </>
  ) : null;

export default Loader;
